import styled from 'styled-components';

import { theme } from '@notino/react-styleguide';

export const LoginWrapper = styled.div`
  text-align: center;
  margin-top: 1rem;
`;

export const LoginLink = styled.a`
  cursor: pointer;
  text-decoration: underline;
  color: ${theme.palette.neutralDarker};
  margin-left: 0.5rem;

  &:hover {
    text-decoration: none;
  }
`;

export const StepProgressCircle = styled.div<{ isFulfilled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  background: ${(props) =>
    props.isFulfilled ? theme.palette.basic : theme.palette.neutralLight};
  border-radius: 50%;
  margin-right: 1.125rem;
`;

export const StepWrapper = styled.span`
  display: flex;
  width: 100%;
  margin: 1rem auto;
  text-align: left;
`;
